import {HandleReactComponentRendering} from '@ClientBase/React/RenderReactComponents'
import {declareClientPackage, RuntimeDetails} from "@ClientBase/IClientPackage";
import { JobFiltersEventHandler } from "@ClientBase/Generic/JobFiltersEventHandler";
import { PostFiltersEventHandler } from "@ClientBase/Generic/PostFiltersEventHandler";
import { BurgerMenuEventHandler } from "@ClientBase/Generic/BurgerMenuEventHandler";
import { CreateCarousels } from "./CarouselsNew";
import * as VideoSnippet from "./VideoSnippet";
import * as TabSwitcher from "./TabSwitcher";
import * as Accordion from "./Accordion";
import * as DomMainipulations from "./DomMainipulations";
import * as Navigation from "./Navigation";
import * as BrowserJobsOVerlay from "./BrowseJobsOverlay";
import * as Filters from "./Filters";
import * as StickyApply from "./StickyApply";
import * as JobTile from "./JobTile";
import * as Modal from "./Modal";
import * as PostTile from "./PostTile";
import * as ListWidget from "./ListWidget";
import * as SocialProfile from "./SocialProfileWidget";
import * as Footer from "./Footer";
import * as Stats from "./Stats";


/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
}

declareClientPackage({
    onDocumentReady(details: RuntimeDetails) {
        Navigation.navigationFunctions();
        DomMainipulations.removeSocialWidgetIfEmpty();
        JobFiltersEventHandler.useAttraxTsHandlers($);
        PostFiltersEventHandler.useAttraxTShandler($);
        BurgerMenuEventHandler.handleClickEvents($);
        VideoSnippet.VideoClickHandler();
        TabSwitcher.tabswitcherFunctions();
        Accordion.handleAccordions();
        DomMainipulations.homePageScroll($);
        DomMainipulations.moveLinkedInButton($);
        DomMainipulations.moveFilterButton($);
        DomMainipulations.injectJsResource($);
        DomMainipulations.repositionBioModal($);
        DomMainipulations.shortlistRedirect($);
        DomMainipulations.showValidationIfTrue($);
        DomMainipulations.createStickyApplyHeading($);
        DomMainipulations.moveKeyword();
        DomMainipulations.moveSendCvModal($);
        DomMainipulations.removeFooterAutocomplete($);
        DomMainipulations.showExpiredVacancyBanner($);
        DomMainipulations.addClearbtn();
        DomMainipulations.removeNonBreakingSpaceFromJobDetails();
        DomMainipulations.addFilterTextHeadingJobResults();
        DomMainipulations.showAuthorDetailsIfAuthor();
        CreateCarousels();
        Filters.scrollHandler($);
        Filters.jobFiltersLocationClickHandler();
        StickyApply.showStickyApply();
        JobTile.addLogo();
        JobTile.brandClassAssignment();
        JobTile.setActive();
        Modal.closeModalOnBgClick();
        PostTile.makePostTileClickable();
        ListWidget.checkIfJobTilesHaveProfile();
        SocialProfile.displayRecruiterIfAvailable();
        BrowserJobsOVerlay.BrowseJobsOverlay();
        Stats.makeAnimate();

        Footer.FooterHandlers();
        $(document).on("job-filter-initialized", function () {
            (
                window as any
            ).jobFilterNoReloadController.enableDefaultFilterCounts();
        });
    }
});
